<app-landing-page-base [headerText]="headerText" [contentText]="contentText"></app-landing-page-base>
